export const PrepaymentTypes = {
	CANCELED: 0,
	PENDING: 1,
	WAITING: 2,
	PAID: 3,
	FINISHED: 4,
};
